import type { RouteRecordRaw } from 'vue-router'
import { memberCenterBaseRoutePath } from '/@/router/static/memberCenterBase'

/** 使用 HostViewResolver 延迟解析 host，等 initialize 获取到配置后再加载对应模板 */
const hostView = () => import('/@/layouts/common/HostViewResolver.vue')
const pageTitle = (name: string): string => {
	return `pagesTitle.${name}`
}

/*
 * 静态路由
 * 使用 HostViewResolver 包装，在渲染时根据 siteConfig.host 动态加载对应模板
 * 避免模块加载时尚未请求后端、host 未知的问题
 */
const staticRoutes: Array<RouteRecordRaw> = [
	{
		// 首页
		path: '/',
		name: 'home',
		component: hostView,
		meta: {
			title: pageTitle('首页'),
			hostViewPath: '/@/views/index/index.vue',
		},
	},
	{
		// 会员登录页
		path: memberCenterBaseRoutePath + '/login',
		name: 'userLogin',
		component: hostView,
		meta: {
			title: pageTitle('用户登录'),
			hostViewPath: '/@/views/user/login.vue',
		},
	},
	/* {
		// 会员登录页
		path: memberCenterBaseRoutePath + '/reset_password',
		name: 'userResetPassword',
		component: getHostViewComponent('/@/views/user/reset_password.vue'),
		meta: {
			title: pageTitle('重置密码'),
		},
	}, */
	{
		path: '/:path(.*)*',
		redirect: '/404',
	},
	{
		// 404
		path: '/404',
		name: 'notFound',
		component: hostView,
		meta: {
			title: pageTitle('页面不存在'),
			hostViewPath: '/@/views/common/error/404.vue',
		},
	},
	{
		// 会员中心找不到页面了
		path: memberCenterBaseRoutePath + ':path(.*)*',
		redirect: (to) => {
			return {
				name: 'userMainLoading',
				params: {
					to: JSON.stringify({
						path: to.path,
						query: to.query,
					}),
				},
			}
		},
	},
	{
		// 无权限访问
		path: '/401',
		name: 'noPower',
		component: hostView,
		meta: {
			title: pageTitle('无访问权限'),
			hostViewPath: '/@/views/common/error/401.vue',
		},
	},
]

const staticFiles: Record<string, Record<string, RouteRecordRaw>> = import.meta.glob('./static/*.ts', { eager: true })
for (const key in staticFiles) {
	if (staticFiles[key].default) staticRoutes.push(staticFiles[key].default)
}

export default staticRoutes
